import { render, staticRenderFns } from "./DigitalFactory.vue?vue&type=template&id=26a484aa&scoped=true&"
import script from "./DigitalFactory.vue?vue&type=script&lang=js&"
export * from "./DigitalFactory.vue?vue&type=script&lang=js&"
import style0 from "./DigitalFactory.vue?vue&type=style&index=0&id=26a484aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a484aa",
  null
  
)

export default component.exports